import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Useronboard from "./Components/Useronboard";
// import UseronboardFileUploadPOC from "./Components/UseronboardFileUploadPOC";
// import MainLayout from "./Layouts/MainLayout";
import PrivateRoute from "./Routes/PrivateRoute";
import PageNotFound from "./CommonComponents/PageNotFound";
import Chat from "./Components/Chat";
// import ChatPOC from "./Components/ChatPOC";
import ChatHistory from "./CommonComponents/ChatHistory";
import BronxTale from "./Components/StaticComponents/BronxTale";
import PoloBear from "./Components/StaticComponents/PoloBear";
import SpecialDelivery from "./Components/StaticComponents/SpecialDelivery";
import { AbortControllerProvider } from "./Context/AbortControllerContext";
import DynamicComponent from "./Components/StaticComponents/DynamicComponent";
import { environmetService } from "./Services/ApiServices/environmentServices";
import PlainLayout from "./Layouts/PlainLayout";
import { Cookies } from 'react-cookie-consent';
import { AnimatePresence } from "framer-motion";
import { getLowPowerModeStatus, setupLowPowerModeListener } from "./Services/CommonServices/lowPowerModeService";
import { setLowPowerModeStatus, setDetectionError, startDetection } from "./Services/Redux/Reducers/deviceSlice";
// import CameraRecorderDecart from "./Components/CameraRecorderDecart";
// import { DecartProvider } from "./Services/ContextProvider/DecartContextProvider";
// import ImageEditor from "./DecartUploadEdit";
// import DecartRealtimeVTON from "./Components/DecartRealtimeVTON";

const AnimatedRoutes = () => {
  const dispatch = useDispatch();
  const { isDetectionComplete } = useSelector(state => state.device);
  const [dynamicPaths, setDynamicPaths] = useState([]);
  const [bucketUrl, setbucketUrl] = useState(Cookies.get('bucketUrl'));
  const [cardFolder, setCardFolder] = useState(Cookies.get('cardFolder'));
  const location = useLocation();

  useEffect(() => {
    setbucketUrl(Cookies.get('bucketUrl'));
    setCardFolder(Cookies.get('cardFolder'));
    const fetchPath = async() => {
      await getDynamicPaths();
    }
    fetchPath();
  }, [bucketUrl, cardFolder])

  const getDynamicPaths = async () => {
    try {
        // bucketUrl, cardFolder is not defined, skipping dynamic paths fetch
        if (!bucketUrl || !cardFolder) {
          return;
        }
        const response = await fetch(`${bucketUrl}Dynamic_Pages/${cardFolder}/cards.json`)
        if(response.ok){
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            const data = await response.json();
            let a = []
            data.cards.map((x) => {
              a.push(x.path)
              Cookies.set('acceptedPaths', a)
            })
            setDynamicPaths(data.cards);
          } else {
            console.log('Response is not JSON, got content-type:', contentType);
          }
        } else {
          console.log('Failed to fetch dynamic paths. Status:', response.status, 'URL:', `${bucketUrl}Dynamic_Pages/${cardFolder}/cards.json`);
        }
      }
      catch(err){
        console.log('Error occured in fetching dynamic paths. URL attempted:', `${bucketUrl}Dynamic_Pages/${cardFolder}/cards.json`, 'Error:', err.message);
      }
  }

  //fetching environment variables and setting it in localstorage
  useEffect(() => {
    if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
      return;
    }
    const getEnvironmentVariables = () => {
      try {
        environmetService(async(response) => { // for env variables 
          if (response && response.data) {            
            localStorage.setItem('storeChat', response.data.storeChat);
            Cookies.set('applicationEnvironment', response.data.applicationEnvironment);
            setbucketUrl(response.data.bucketUrl);
            setCardFolder(response.data.cardFolder);
            Cookies.set('bucketUrl', response.data.bucketUrl);
            Cookies.set('cardFolder', response.data.cardFolder);
            Cookies.set('feedBackCheckMonth', response.data.feedbackmodalindays)
          } else {
            console.log('Invalid response from environment service:', response);
            localStorage.setItem('storeChat', false);
          }
        }, (err) => {
          localStorage.setItem('storeChat', false);
          console.log('Error occured in fetching environment data:', err.message);
        });
      }
      catch(err){
        console.log('Error occured in fetching dynamic paths',err.message);
        localStorage.setItem('storeChat', false);
      }
    }
    getEnvironmentVariables();
  }, [])

  // Low Power Mode Detection useEffect
  useEffect(() => {
    const initializeLowPowerModeDetection = async () => {
      try {
        dispatch(startDetection());
        
        // Get initial low power mode status
        const status = await getLowPowerModeStatus();
        dispatch(setLowPowerModeStatus(status));
        
        // Set up listener for changes
        const cleanup = setupLowPowerModeListener((isLowPowerMode) => {
        //  console.log('Low power mode status changed:', isLowPowerMode);
          // Update the status in Redux with the new low power mode value
          const updatedStatus = {
            ...status,
            isLowPowerMode,
            timestamp: Date.now()
          };
          dispatch(setLowPowerModeStatus(updatedStatus));
        });
        
        // Return cleanup function
        return cleanup;
      } catch (error) {
        console.error('Error initializing low power mode detection:', error);
        dispatch(setDetectionError(error.message));
      }
    };

    const cleanupPromise = initializeLowPowerModeDetection();
    
    // Cleanup on unmount
    return () => {
      cleanupPromise.then(cleanup => {
        if (cleanup && typeof cleanup === 'function') {
          cleanup();
        }
      });
    };
  }, []);

  return (
    <AnimatePresence mode="wait" initial={false}>
      {isDetectionComplete && (
        <Routes location={location} key={location.pathname}>
          <Route element={<PlainLayout />}>
            <Route 
              path="/" 
              element={
              <PrivateRoute>
                <Useronboard 
                  bucketUrl={bucketUrl}
                  cardFolder={cardFolder}
                />
              </PrivateRoute>
              }
            />
            {/* <Route 
              path="/useronboardPOC" 
              element={
              <PrivateRoute>
                <DecartProvider>
                <UseronboardFileUploadPOC
                  bucketUrl={bucketUrl}
                  cardFolder={cardFolder}
                />
                </DecartProvider>
              </PrivateRoute>
              }
            />
            <Route 
              path="/imgEdit" 
              element={
              <PrivateRoute>
                <DecartProvider>
                <ImageEditor 
                  bucketUrl={bucketUrl}
                  cardFolder={cardFolder}
                />
                </DecartProvider>
              </PrivateRoute>
              }
            />
            <Route 
              path="/camera" 
              element={
              <PrivateRoute>
                <CameraRecorderDecart 
                  bucketUrl={bucketUrl}
                  cardFolder={cardFolder}
                />
              </PrivateRoute>
              }
            />
            <Route 
              path="/vton" 
              element={
              <PrivateRoute>
                <DecartProvider>
                  <DecartRealtimeVTON />
                </DecartProvider>
              </PrivateRoute>
              }
            />
            <Route
              path="/chatPoc"
              element={
                <PrivateRoute>
                  <AbortControllerProvider>
                    <ChatPOC bucketUrl={bucketUrl}/>
                  </AbortControllerProvider>
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/chat"
              element={
                <PrivateRoute>
                  <AbortControllerProvider>
                    <Chat bucketUrl={bucketUrl}/>
                  </AbortControllerProvider>
                </PrivateRoute>
              }
            />
            <Route
              path="/chatHistory"
              element={
                <PrivateRoute>
                  <ChatHistory />
                </PrivateRoute>
              }
            />
            <Route
            path="/bronxtale"
            element={
              <PrivateRoute>
                <BronxTale />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/polar"
            element={
              <PrivateRoute>
                <PoloBear />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/specialDelivery"
            element={
              <PrivateRoute>
                <SpecialDelivery />
              </PrivateRoute>
            }
          />
          </Route>
          {
            dynamicPaths?.map((path, id) => (
              <Route
                id={"routeId-" + id}
                key={"routeId-" + id}
                exact
                path={path.path}
                element={
                  <PrivateRoute>
                    <DynamicComponent bucketUrl={bucketUrl} cardFolder={cardFolder} />
                  </PrivateRoute>
                }
              />
            ))
          }
          {/* Common Header Layout */}
          {/* <Route element={<MainLayout />}>
          </Route> */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      )}
    </AnimatePresence>
  );
}

function App({ Router = BrowserRouter }) {
  // Add CSS animation for loading spinner
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;